import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { useTranslation } from "react-i18next";

import BackButton from "./back-button";
import { BooleanMenuItem } from "./types";

const BOOLEAN_OPTIONS = [
  { value: "1", labelKey: "booleanYes" },
  { value: "0", labelKey: "booleanNo" },
] as const;

export default function BooleanPanel({
  menuItem,
  value,
  onChange,
  onBack,
}: {
  menuItem: BooleanMenuItem;
  value?: string;
  onChange: (value: string) => void;
  onBack: () => void;
}) {
  const { t } = useTranslation();

  return (
    <div>
      <BackButton label={menuItem.label} onBack={onBack} />
      {BOOLEAN_OPTIONS.map((option) => {
        const isSelected = value === option.value;
        return (
          <DropdownMenu.Item
            key={option.value}
            onSelect={(e) => {
              e.preventDefault();
              onChange(option.value);
            }}
            className="flex cursor-pointer select-none items-center gap-3 rounded-md px-3 py-2 text-sm text-default outline-none hover:bg-tint focus:bg-tint focus:ring-2 focus:ring-focus"
          >
            <div
              className={`flex h-4 w-4 shrink-0 items-center justify-center rounded-full border ${isSelected ? "border-primary" : "border-default"}`}
            >
              {isSelected && (
                <div className="h-2 w-2 rounded-full bg-primary" />
              )}
            </div>
            <span className="flex-1">{t(option.labelKey)}</span>
          </DropdownMenu.Item>
        );
      })}
    </div>
  );
}
